export const appReady = {
  get() {
    return JSON.parse(localStorage.getItem('app_ready'));
  },
  set(value) {
    JSON.stringify(localStorage.setItem('app_ready', value));
  },
};
